import getEncodedVerifierKey from './getEncodedVerifierKey'
export const removeStateFromStorage = ({ client_id, storage }) => {
  const key = getEncodedVerifierKey(client_id);
  storage.removeItem(key);
}
